import { WorkoutGuard } from './../@auth/guards/workout.guard';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NbCardModule,
  NbDialogModule,
  NbLayoutModule,
  NbMenuModule,
  NbOptionModule,
  NbCalendarModule,
  NbSelectModule,
  NbCardComponent,
  NbSpinnerModule,
  NbIconModule,
  NbThemeService,
  NbSidebarModule,
  NbBadgeModule,
  NbButtonModule,
  NbToast,
  NbToastrModule,
} from '@nebular/theme';

import { NbEvaIconsModule } from '@nebular/eva-icons';

import { CookieService } from 'ngx-cookie-service';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { ComponentsModule } from 'app/@components/components.module';
import { MaterialModule } from 'app/@components/material.module';
import { CalorieFriendModule } from 'app/pages/CalorieFriend/calorie-friend.module';
import { GraphModule } from 'app/admin/public-foods/meal-metrics-graph/meal-metrics-graph.module';
import { MealItemPresentationModule } from 'app/pages/CalorieFriend/Plans/PlanMeals/Meal/MealLayout/MealItemPresentation/meal-item-presentation.module';
import { MealPresentationModule } from 'app/pages/CalorieFriend/Plans/PlanMeals/Meal/MealLayout/MealPresentation/meal-presentation.module';
import { FrontendsRoutingModule } from './frontends-routing.module';

import { FrontendsComponent } from './frontends.component';
import { PatientGoalsComponent } from './patient-goals/patient-goals.component';
import { PatientProfileInvalidComponent } from './patient-profile-invalid/patient-profile-invalid.component';
import { PatientProfileComponent } from './patient-profile/patient-profile.component';
import { PatientMealPlanViewComponent } from './patient-meal-plan-view/patient-meal-plan-view.component';
import { PatientFitnessPlanViewComponent } from './patient-fitness-plan-view/patient-fitness-plan-view.component';
import { NativeappAdvertComponent } from './nativeapp-advert/nativeapp-advert.component';
import { PatientCheckinComponent } from './patient-checkin/patient-checkin.component';
import { PatientCalendarViewComponent } from './patient-calendar-view/patient-calendar-view.component';
import { PatientFitnessWorkoutLogsViewComponent } from './patient-fitness-workout-logs-view/patient-fitness-workout-logs-view.component';
import { PatientsService } from 'app/@core/backend/common/services/CalorieFriend/patients.service';
import { FoodDiaryContainerComponent } from './food-tracking/food-diary-container/food-diary-container.component';
import { ChatModule } from 'app/@chat/chat.module';
import { PatientInvoicesComponent } from './patient-billing/patient-invoices/patient-invoices.component';
import { PatientInvoiceViewComponent } from './patient-billing/patient-invoice-view/patient-invoice-view.component';
import { RouterModule } from '@angular/router';
import { PatientSubscriptionsComponent } from './patient-billing/patient-subscriptions/patient-subscriptions.component';
import { PatientBillingComponent } from './patient-billing/patient-billing.component';
import { PatientSubscriptionViewComponent } from './patient-billing/patient-subscription-view/patient-subscription-view.component';
import { PatientSubscriptionMetaViewComponent } from './patient-billing/patient-subscription-meta-view/patient-subscription-meta-view.component';
const FRONTENDS_COMPONENTS = [
  FrontendsComponent,
  PatientMealPlanViewComponent,
  PatientProfileComponent,
  PatientGoalsComponent,
  PatientProfileInvalidComponent,
  PatientFitnessPlanViewComponent,
  PatientFitnessWorkoutLogsViewComponent,
  PatientCalendarViewComponent,
  PatientInvoicesComponent,
  PatientInvoiceViewComponent,
  PatientSubscriptionsComponent,
  PatientSubscriptionViewComponent,
  PatientSubscriptionMetaViewComponent,
  PatientBillingComponent,
];

const NB_MODULES = [
  NbLayoutModule,
  NbOptionModule,
  NbMenuModule,
  NbSelectModule,
  NbSelectModule,
  NbDialogModule,
  NbToastrModule,
  NbCardModule,
  NbCalendarModule,
  NbSpinnerModule,
  NbEvaIconsModule,
  NbIconModule,
  NbSidebarModule,
  NbBadgeModule,
  NbButtonModule,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FrontendsRoutingModule,
    ...NB_MODULES,
    ComponentsModule,
    MaterialModule,
    MealItemPresentationModule,
    MealPresentationModule,
    GraphModule,
    CalorieFriendModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    ChatModule,
  ],
  declarations: [
    ...FRONTENDS_COMPONENTS,
    NativeappAdvertComponent,
    PatientCheckinComponent,
    FoodDiaryContainerComponent,
  ],
  providers: [CookieService, PatientsService],
})
export class FrontendsModule {}
